export type BrandColourModel = {
  cache_key: string,
  id: number,
  brand_id: number,
  cmyk: {
    c: string,
    k: string,
    m: string,
    y: string,
  },
  rgb: {
    b: string,
    g: string,
    r: string,
  },
  spot_colour_name?: string,
  title: string,
}

export type BrandColourRequestOptions = {}

const validateNumber = (
  value: string,
  min: number,
  max: number,
) => value !== '' && Number(value) >= min && Number(value) <= max

const state = {
  brand_id: undefined,
  cmyk: {
    c: '',
    k: '',
    m: '',
    y: '',
  },
  id: null,
  rgb: {
    b: '',
    g: '',
    r: '',
  },
  spot_colour_name: '',
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  // @ts-expect-error TS7006
  { key: 'cmyk.c', validation: value => validateNumber(value, 0, 100), invalidMessage: 'Invalid Number' },
  // @ts-expect-error TS7006
  { key: 'cmyk.m', validation: value => validateNumber(value, 0, 100), invalidMessage: 'Invalid Number' },
  // @ts-expect-error TS7006
  { key: 'cmyk.y', validation: value => validateNumber(value, 0, 100), invalidMessage: 'Invalid Number' },
  // @ts-expect-error TS7006
  { key: 'cmyk.k', validation: value => validateNumber(value, 0, 100), invalidMessage: 'Invalid Number' },
  // @ts-expect-error TS7006
  { key: 'rgb.r', validation: value => validateNumber(value, 0, 255), invalidMessage: 'Invalid Number' },
  // @ts-expect-error TS7006
  { key: 'rgb.g', validation: value => validateNumber(value, 0, 255), invalidMessage: 'Invalid Number' },
  // @ts-expect-error TS7006
  { key: 'rgb.b', validation: value => validateNumber(value, 0, 255), invalidMessage: 'Invalid Number' },
  { key: 'title' },
]

export default state
